import React, {PropTypes} from "react";
import {connect} from "react-redux";
import axios from "axios";
import LoadingSpinner from "../../loadingSpinner";
import AbscondTable from "./AbscondTable";
import toastr from "toastr";
import * as actions from "../../../redux/actions/Employee/employeeDetailActions";

class AbscondHome extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        abscondData:[],
        loading:true,
        open: false,
    }
    this.moveToExitConfirm = this.moveToExitConfirm.bind(this);
    this.moveToExit = this.moveToExit.bind(this);
    this.refresh = this.refresh.bind(this);
    this.close = this.close.bind(this);
  }

  close() {
    this.setState({open: false});
  }

  refresh(empId){
    this.props.dispatch(actions.refreshEmployee(empId))
    let tab;
    if(window.location.href.indexOf("teamAbsconds")>-1){
        tab="teamAbscond"
    }
    else{
        tab="hrAbscond"
    }
    axios.get(process.env.REQ_URL + "/getAbscond?q=" + tab, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employees = response.data.data;

      this.setState({abscondData: employees, loading: false})
    }).catch((err)=> {

    });
  }

  moveToExitConfirm(empId){
    let request = {
      "empId":empId
    };

    axios.post(process.env.REQ_URL + "/exit/moveToExitConfirm", {data:request}, {withCredentials:true, headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response) => {
      toastr.success("Moved To Exit Successfully for HR Confirmation");

      this.refresh();

    }).catch(error => {
      console.log(error);
    });

  }

  moveToExit(empId,fullName,abscondFrom){

    let abscondFromDay = new Date(abscondFrom);
    abscondFromDay = abscondFromDay.getTime();
    let request= {
      "id":null,
      "empId":empId,
      "name":fullName,
      "noticePeriodStatus":"Abscond",
      "doLeaving":abscondFromDay,
      "doResignation" : abscondFromDay,
      "typeOfExit":"abscond",
      "remarks":"",
      "status":"R",
      "gardening":null,
      "recovery":0
    }

    let exitData = new FormData();
    exitData.append('picture', null);
    exitData.append('recovery', request.recovery);
    exitData.append('name', request.name);
    exitData.append('doLeaving', request.doLeaving);
    exitData.append('doResignation', request.doResignation);
    exitData.append('empId', request.empId);
    exitData.append('gardening', request.gardening);
    exitData.append('noticePeriodStatus', request.noticePeriodStatus);
    exitData.append('remarks', request.remarks);
    exitData.append('status', request.status);
    exitData.append('typeOfExit', request.typeOfExit);
    exitData.append('page', "abscondHome");

    let xhr = new XMLHttpRequest();
    xhr.open('POST', process.env.REQ_URL + "/applyExit", true);
    xhr.responseType = 'json';
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.withCredentials = true;

    // Set up a handler for when the request finishes.
    xhr.onload = function () {
      if (xhr.status === 200) {
        this.close();
        this.refresh(request.empId);
        toastr.success("Moved To Exit Successfully!")
        // File(s) uploaded.
      } else {
        alert('An error occurred!');
      }
    }.bind(this);
    xhr.send(exitData);
    console.log("request: ", request);

    // axios.post(process.env.REQ_URL +  "/applyExit", {data: request}, {withCredentials:true, headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response) => {
    //   toastr.success("Moved To Exit Successfully");

    //   this.refresh();
    // }).catch(eroor => {

    // });

  }

  componentDidMount(){
    this.props.changeBanner("Abscond");
    let tab;
    if(window.location.href.indexOf("teamAbsconds")>-1){
        tab="teamAbscond"
    }
    else{
        tab="hrAbscond"
      }

    axios.get(process.env.REQ_URL + "/getAbscond?q=" + tab,
        {withCredentials: true,
        headers:{
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
        }
      }).then(response=>response.data)
    .then((response)=>{
       this.setState({
        abscondData:response.data,
        loading:false
       });
    }).catch((error)=>{

    })
  }

  render()  {
    if(this.state.loading){
        return <LoadingSpinner/>
    }
    return (
        <AbscondTable
          employees={this.state.abscondData}
          refresh = {this.refresh}
          moveToExitConfirm = {this.moveToExitConfirm}
          moveToExit={this.moveToExit}
        />
    );
  }

}

AbscondHome.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state
  };
}

export default connect(mapStateToProps)(AbscondHome);




/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/abscond/AbscondHome.js
 **/